<div class="status-wrapper" *ngIf="gatewayStatus$ | async as gatewayStatus">
  <app-pill
    data-at-status-pill
    [type]="pillType.errorInverted"
    *ngIf="isLockedSystemError$ | async; else showAggregatedStatus"
  >
    {{ '+INSTALLATIONS.INSTALLATIONS.DASHBOARD.COLD_SYSTEM' | translate }}
  </app-pill>

  <ng-template #showAggregatedStatus>
    <app-pill data-at-status-pill [type]="pillType.success" *ngIf="gatewayStatus?.worksProperly">
      {{ '+INSTALLATIONS.INSTALLATIONS.DASHBOARD.WORKING' | translate }}
    </app-pill>
    <app-pill
      data-at-status-pill
      [type]="pillType.error"
      *ngIf="gatewayStatus?.error || (getActiveGatewayErrors$ | async)?.length"
    >
      {{ '+INSTALLATIONS.INSTALLATIONS.DASHBOARD.FAULT' | translate }}
    </app-pill>
    <app-pill
      data-at-status-pill
      [type]="pillType.primary"
      *ngIf="gatewayStatus?.maintenance"
      [matTooltip]="maintenanceNotificationTooltip | tooltipListPipe"
      matTooltipClass="tooltip-list"
    >
      {{ '+INSTALLATIONS.INSTALLATIONS.DASHBOARD.MAINTENANCE' | translate }}
    </app-pill>
    <app-pill data-at-status-pill [type]="pillType.info" *ngIf="gatewayStatus?.remoteDiagnostic">
      {{ '+INSTALLATIONS.INSTALLATIONS.DASHBOARD.REMOTE_DIAGNOSTIC' | translate }}
    </app-pill>
    <app-pill data-at-status-pill [type]="pillType.secondary" *ngIf="gatewayStatus?.nbiot">
      {{ '+INSTALLATIONS.INSTALLATION.AGGREGATED_STATUS.NBIOT' | translate }}
    </app-pill>
    <app-pill data-at-status-pill [type]="pillType.secondary" *ngIf="gatewayStatus?.offline">
      {{ '+INSTALLATIONS.INSTALLATIONS.DASHBOARD.OFFLINE' | translate }}
    </app-pill>
  </ng-template>
</div>
